export const GET_CHOICES_REQUEST = 'GET_CHOICES_REQUEST';
export const GET_CHOICES_SUCCESS = 'GET_CHOICES_SUCCESS';
export const GET_CHOICES_FAIL = 'GET_CHOICES_FAIL';
